import React, {useEffect, useRef, useState} from 'react';
import {
    Affix,
    Anchor,
    Button,
    Card,
    Cascader,
    Divider,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Result,
    Segmented,
    Tabs,
    FloatButton
} from "antd";
import {Header} from "antd/es/layout/layout";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";

import Cookies from "js-cookie";
import copy from "copy-to-clipboard";

import {CopyOutlined, ExclamationCircleOutlined, ReloadOutlined, SearchOutlined, SendOutlined, SmileOutlined} from "@ant-design/icons";

/*import { HashLink as Link } from 'react-router-hash-link';*/
const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};


const Search_ui_index = () => {


    document.title='快捷搜索'

    const data_time = dayjs().unix();

    const navigate = useNavigate();

    const [user_token, setuser_token] = useState('')



    const [search_type_value,setsearch_type_value]=useState('scene_search_title')

    const [knowledge_detail_search_u_modal_open, setknowledge_detail_search_u_modal_open] = useState(false)

    const [knowledge_detail_search_u_select_info, setknowledge_detail_search_u_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_search_u_select_log, setknowledge_detail_search_u_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_search_u = (e1: any) => {

        setknowledge_detail_search_u_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_search_u_modal_open(true);

        setknowledge_detail_search_u_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_search_u_modal_oncancel = () => {

        setknowledge_detail_search_u_modal_open(false);
    }


    const [knowledge_detail_search_u_modal_form] = Form.useForm();

    const knowledge_detail_search_u_modal_initialValues = { search_value:''}

    const [knowledge_detail_search_u_modal_onfinish_select_log, setknowledge_detail_search_u_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_search_u_modal_onfinish_select_info, setknowledge_detail_search_u_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_search_u_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_search_u_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setknowledge_detail_search_u_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }
    const [Options, setOptions] = useState([{ label: '',
        value: ''}])


    const [return_data_knowledge_detail_search_u, setreturn_data_knowledge_detail_search_u] = useState({
        "message": 0,
        "value": "获取成功",
        "info": {
            "scene": [
                {
                    "id": "175",
                    "uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                    "userid": null,
                    "title": "1",
                    "created": null,
                    "status": "en",
                    "updated": null,
                    tab1_uuid: '',
                    tab1_info: {
                        "id": "34",
                        "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                        "userid": null,
                        "sort_name": "手机模式",
                        "created": null,
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "0",
                        "product_uuid": "100001"
                    },
                    tab2_uuid: '',
                    tab2_info: {
                        "id": "34",
                        "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                        "userid": null,
                        "sort_name": "手机模式",
                        "created": null,
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "0",
                        "product_uuid": "100001"
                    },
                    "parent_uuid": "e83b70c7-d647-44cc-a4cc-08ee8f2210ac",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": null,

                    product_info: {
                        "id": "1",
                        "uuid": "100001",
                        "name": "12999",
                        "description": "21",
                        "category_id": "1",
                        "sort_all_uuid": [
                            "e4bfc3a1-ce48-4053-b9e6-de22312cb4cb",
                            "6971bff0-12a2-44d8-a0e8-434825814f86"
                        ],
                        "sort_end_uuid": "6971bff0-12a2-44d8-a0e8-434825814f86",
                        "brand_id": "1",
                        "sort_shop_uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                        "status": "1",
                        "status_type": "删除",
                        "buy_it_now": "21",
                        "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                        "region_id": "6666",
                        "created": "1",
                        "node_value": "999",
                        "updated": "1732841757",
                        "created_at": "2024-10-24 14:29:00",
                        "updated_at": "2024-11-29 08:55:57",
                        "country_code": "56888"
                    },
                    "row_num": null,
                    "scene_question": [
                        {
                            "id": "171",
                            "uuid": "57c7969e-627d-4a49-ba25-d3057ad178ca",
                            "title": "999",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ],
                    "scene_solution": [
                        {
                            "id": "164",
                            "uuid": "b2b0cf88-ca6e-49fe-96e2-3d6d3e5ea307",
                            "title": "111+",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ]
                }
            ],
            "scene_question": [
                {
                    "id": "176",
                    "uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                    "userid": null,
                    "title": "100",
                    "created": null,
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "f7bf044e-edf0-431e-ac67-dd6ac90a103d",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": null,
                    "row_num": null,
                    "scene_question": [
                        {
                            "id": "173",
                            "uuid": "5ec9f426-5db6-4c7c-8f8f-9f2828364a86",
                            "title": "21",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        },
                        {
                            "id": "174",
                            "uuid": "c213edba-299c-4768-a2ce-1bace9846077",
                            "title": "21",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        },
                        {
                            "id": "175",
                            "uuid": "ede2aaa3-c36f-4f59-9e6b-a1b543783679",
                            "title": "21165啊是否萨蒂发",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ],
                    "scene_solution": [
                        {
                            "id": "169",
                            "uuid": "88b639e3-a3e3-4c55-83d0-08cf44b6e3c2",
                            "title": "11",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        },
                        {
                            "id": "170",
                            "uuid": "55ee28fa-bef2-4751-840f-1418a32c427f",
                            "title": "1199",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ]
                }
            ],
            "scene_solution": [
                {
                    "id": "175",
                    "uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                    "userid": null,
                    "title": "1",
                    "created": null,
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "e83b70c7-d647-44cc-a4cc-08ee8f2210ac",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": null,
                    "row_num": null,
                    "scene_question": [
                        {
                            "id": "171",
                            "uuid": "57c7969e-627d-4a49-ba25-d3057ad178ca",
                            "title": "999",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ],
                    "scene_solution": [
                        {
                            "id": "164",
                            "uuid": "b2b0cf88-ca6e-49fe-96e2-3d6d3e5ea307",
                            "title": "111+",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "product_uuid": "100001",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": null
                        }
                    ]
                }
            ]
        }
    });



    const knowledge_detail_search_u_body = new FormData();


    knowledge_detail_search_u_body.append('finish_data', JSON.stringify(knowledge_detail_search_u_modal_onfinish_select_info.value1));

    knowledge_detail_search_u_body.append('search_type', search_type_value);

    knowledge_detail_search_u_body.append('userToken',  String(Cookies.get('userToken_chattool')));

    knowledge_detail_search_u_body.append('time', String(knowledge_detail_search_u_modal_onfinish_select_info.time));

    knowledge_detail_search_u_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/search/fetch/search_fetch_keybord.php', {


                method: 'POST',
                body: knowledge_detail_search_u_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //  message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setknowledge_detail_search_u_modal_open(false)

                    setreturn_data_knowledge_detail_search_u(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})


                    if (return_data && return_data.info && return_data.info.scene) {
                        // 创建一Map 来存储唯一的产品信息，uuid 为键
                        const uniqueProductMap = new Map();

                        return_data.info.scene.forEach((item: any) => {
                            if (item.product_info && item.product_info.uuid) {
                                uniqueProductMap.set(item.product_info.uuid, {
                                    label: item.product_info.name,
                                    value: item.product_info.uuid,
                                });
                            }
                        });

                        // Map 转换为数
                        const uniqueOptions = Array.from(uniqueProductMap.values());
console.log(uniqueOptions)
        setOptions(uniqueOptions);

                    }

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if (knowledge_detail_search_u_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_search_u_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_search_u_modal_onfinish_select_log]);


    const copy_clipbord = (message_v: any) => {

      console.log(message_v)
        copy(message_v)
        message.success('复制成功');

    }

    const send_message = (message_v: any) => {

     /*   copy(message_v)*/

    console.log(message_v)

    }


    const [search_fetch_product_keybord_select_info, setsearch_fetch_product_keybord_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [search_fetch_product_keybord_select_log, setsearch_fetch_product_keybord_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const search_fetch_product_keybord = (e1: any) => {

        setsearch_fetch_product_keybord_select_log({message: 'click', value: '', time: data_time})


        setsearch_fetch_product_keybord_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_search_fetch_product_keybord, setreturn_data_search_fetch_product_keybord] = useState({});

    const search_fetch_product_keybord_body = new FormData();


    search_fetch_product_keybord_body.append('userToken',  String(Cookies.get('userToken_chattool')));
    search_fetch_product_keybord_body.append('search_type', search_type_value);
    search_fetch_product_keybord_body.append('product_uuid', search_fetch_product_keybord_select_info.value1);
    search_fetch_product_keybord_body.append('finish_data', JSON.stringify(knowledge_detail_search_u_modal_onfinish_select_info.value1));


    search_fetch_product_keybord_body.append('time', String(search_fetch_product_keybord_select_info.time));

    search_fetch_product_keybord_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/search/fetch/search_fetch_product_keybord.php', {


                method: 'POST',
                body: search_fetch_product_keybord_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

//获取消息，无需提示
                    /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_search_fetch_product_keybord(return_data);
                    setreturn_data_knowledge_detail_search_u(return_data);

                    //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if (search_fetch_product_keybord_select_log.message !== '') {

            data_async();
            setsearch_fetch_product_keybord_select_log({message: '', value: '', time: 0})
        }
    }, [search_fetch_product_keybord_select_log]);


    const search_onchange_cascader_option = (e1: any) => {

        console.log({cascader_value: e1})


        if (e1 === undefined) {


            setknowledge_detail_search_u_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})


        } else {

            setsearch_fetch_product_keybord_select_log({message: 'click', value: '', time: data_time})


            setsearch_fetch_product_keybord_select_info({value1: e1, value2: '', value3: '', time: data_time})


        }
    }


    /*
        const handleAnchorClick = (e: any, link: any) => {
            e.preventDefault(); // 阻止默认行为
            const targetElement = document.querySelector(link.href);
            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        };
    */


    const knowledge_detail_search_u_modal_onValuesChange = (e1: any) => {

        if (e1.search_value === '') {


            setreturn_data_knowledge_detail_search_u(  {"message": 0,
                "value": "获取成功",
                "info": {
                    "scene": [
                        {
                            "id": "175",
                            "uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "userid": null,
                            "title": "1",
                            "created": null,
                            "status": "en",
                            "updated": null,
                            tab1_uuid: '',
                            tab1_info: {
                                "id": "34",
                                "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                                "userid": null,
                                "sort_name": "手机模式",
                                "created": null,
                                "status": "en",
                                "updated": null,
                                "parent_uuid": "0",
                                "product_uuid": "100001"
                            },
                            tab2_uuid: '',
                            tab2_info: {
                                "id": "34",
                                "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                                "userid": null,
                                "sort_name": "手机模式",
                                "created": null,
                                "status": "en",
                                "updated": null,
                                "parent_uuid": "0",
                                "product_uuid": "100001"
                            },
                            "parent_uuid": "e83b70c7-d647-44cc-a4cc-08ee8f2210ac",
                            "country_code": "56888",
                            "region_parent_id": null,
                            "region_id": null,

                            product_info: {
                                "id": "1",
                                "uuid": "100001",
                                "name": "12999",
                                "description": "21",
                                "category_id": "1",
                                "sort_all_uuid": [
                                    "e4bfc3a1-ce48-4053-b9e6-de22312cb4cb",
                                    "6971bff0-12a2-44d8-a0e8-434825814f86"
                                ],
                                "sort_end_uuid": "6971bff0-12a2-44d8-a0e8-434825814f86",
                                "brand_id": "1",
                                "sort_shop_uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                                "status": "1",
                                "status_type": "删除",
                                "buy_it_now": "21",
                                "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                                "region_id": "6666",
                                "created": "1",
                                "node_value": "999",
                                "updated": "1732841757",
                                "created_at": "2024-10-24 14:29:00",
                                "updated_at": "2024-11-29 08:55:57",
                                "country_code": "56888"
                            },
                            "row_num": null,
                            "scene_question": [
                                {
                                    "id": "171",
                                    "uuid": "57c7969e-627d-4a49-ba25-d3057ad178ca",
                                    "title": "999",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ],
                            "scene_solution": [
                                {
                                    "id": "164",
                                    "uuid": "b2b0cf88-ca6e-49fe-96e2-3d6d3e5ea307",
                                    "title": "111+",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ]
                        }
                    ],
                    "scene_question": [
                        {
                            "id": "176",
                            "uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                            "userid": null,
                            "title": "100",
                            "created": null,
                            "status": "en",
                            "updated": null,
                            "parent_uuid": "f7bf044e-edf0-431e-ac67-dd6ac90a103d",
                            "country_code": "56888",
                            "region_parent_id": null,
                            "region_id": null,
                            "row_num": null,
                            "scene_question": [
                                {
                                    "id": "173",
                                    "uuid": "5ec9f426-5db6-4c7c-8f8f-9f2828364a86",
                                    "title": "21",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                },
                                {
                                    "id": "174",
                                    "uuid": "c213edba-299c-4768-a2ce-1bace9846077",
                                    "title": "21",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                },
                                {
                                    "id": "175",
                                    "uuid": "ede2aaa3-c36f-4f59-9e6b-a1b543783679",
                                    "title": "21165啊是否萨蒂发",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ],
                            "scene_solution": [
                                {
                                    "id": "169",
                                    "uuid": "88b639e3-a3e3-4c55-83d0-08cf44b6e3c2",
                                    "title": "11",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                },
                                {
                                    "id": "170",
                                    "uuid": "55ee28fa-bef2-4751-840f-1418a32c427f",
                                    "title": "1199",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "f3aeabb3-6ee6-4be6-b1fe-47a4de5158c5",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ]
                        }
                    ],
                    "scene_solution": [
                        {
                            "id": "175",
                            "uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                            "userid": null,
                            "title": "1",
                            "created": null,
                            "status": "en",
                            "updated": null,
                            "parent_uuid": "e83b70c7-d647-44cc-a4cc-08ee8f2210ac",
                            "country_code": "56888",
                            "region_parent_id": null,
                            "region_id": null,
                            "row_num": null,
                            "scene_question": [
                                {
                                    "id": "171",
                                    "uuid": "57c7969e-627d-4a49-ba25-d3057ad178ca",
                                    "title": "999",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ],
                            "scene_solution": [
                                {
                                    "id": "164",
                                    "uuid": "b2b0cf88-ca6e-49fe-96e2-3d6d3e5ea307",
                                    "title": "111+",
                                    "solution": null,
                                    "finish_data_values": null,
                                    "parent_uuid": "578ddd22-5abd-4f41-acef-d401afc4ba61",
                                    "product_uuid": "100001",
                                    "parent_id": null,
                                    "user_token": null,
                                    "status": "en",
                                    "country_code": "56888",
                                    "created": null,
                                    "deleted": null,
                                    "updated": null,
                                    "isshow": null
                                }
                            ]
                        }
                    ]
                }
            });
            /* message.info('内容不能为空')*/

            /*    setOptions([])*/

            //  setreturn_data_knowledge_detail_search_u(null)

        } else {


            /*   setOptions([])*/
            console.log({value_change: e1})
            setknowledge_detail_search_u_modal_onfinish_select_log({message: 'e1', value: '', time: data_time})
            setknowledge_detail_search_u_modal_onfinish_select_info({
                value1: e1,
                value2: '',
                value3: '',
                time: data_time
            })

        }


    }
    const inputRef = useRef(null);
    const [auto_focus_status, setauto_focus_status] = useState(true)


    const cleanHref = (href: string): string => href.replace(/#+/g, "#").replace(/#\/#/, "#/");

    const handleScroll = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    };

    const handleAnchorClick = (e1: any, e2: any) => {


        console.log({e1: e1, e2: e2, e23: e1.target.hash})
        handleScroll(e1.target.hash)
    }


    const search_onpressenter=()=>{

        if(knowledge_detail_search_u_modal_form.getFieldValue('search_value')!=='') {

            setknowledge_detail_search_u_modal_onfinish_select_log({message: 'e1', value: '', time: data_time})
        }
    }

    return (


        <div className="admin-fill-page admin-search-page">


            <Card style={{    backgroundColor: '#ffffff',}}>

                {/* <Header style={{height: 30, backgroundColor: '#ffffff',}}>


                </Header>*/}


           {/*     <Affix offsetTop={0} style={{
                    transform: 'none', backgroundColor: '#ffffff', // 白色背景
                }}>

                    <Header style={{height: 30, backgroundColor: '#ffffff',}}>


                    </Header>


                </Affix>
*/}

                <Segmented<string> defaultValue={'scene_search_title'}
                    options={[{label: '问题', value: 'scene_search_title'}, {label: '问法', value: 'scene_search_question'}, {label: '回复', value: 'scene_search_solution'},]}
                    onChange={(value) => {
                        if(knowledge_detail_search_u_modal_form.getFieldValue('search_value')!=='') {

                            setknowledge_detail_search_u_modal_onfinish_select_log({message: 'e1', value: '', time: data_time})
                        }
                        setsearch_type_value(value)
                        console.log(value); // string
                    }}
                />
                <p></p>
                <Flex className="admin-search-layout">

                    <div className="admin-search-filter-panel">


                        <Form form={knowledge_detail_search_u_modal_form}
                              initialValues={knowledge_detail_search_u_modal_initialValues}
                            /* onFinish={knowledge_detail_search_u_modal_onfinish}*/

                              onValuesChange={knowledge_detail_search_u_modal_onValuesChange}
                        >


                            <Form.Item name={'search_value'}>

                                <Input.Search ref={inputRef} onPressEnter={search_onpressenter} placeholder="请输入搜索内容">


                                </Input.Search>


                            </Form.Item>


                            {/*           <Button htmlType={'submit'} type={'primary'}>提交</Button>
                            <Button style={{marginLeft:10}} onClick={setknowledge_detail_search_u_modal_oncancel}>取消</Button>
*/}
                        </Form>


        <div>


                            {return_data_knowledge_detail_search_u.info.scene.length <= 0 ? <></> :
                                <div> {return_data_knowledge_detail_search_u.message !== 2000 ? <div></div> :
                                    <div><label style={{fontSize: 14}}>筛选商品：</label>
                                        <p></p>
                                        <Cascader style={{width: '100%'}} placeholder={'选择商品'} onChange={search_onchange_cascader_option}
                                                  options={Options}/>
                                    </div>}</div>}

                        </div>


                    </div>

                    {/*<Anchor  items={[
    {
        key: 'b433d596-174a-4893-9924-af6a3f8fe3e5',
        href: cleanHref('#/search#b433d596-174a-4893-9924-af6a3f8fe3e5'),
        title: 'Part 1',
    },
    {
        key: 'part-2',
        href: '#/search#part-2',
        title: 'Part 2',
    },
    {
        key: '42342542-6076-40fc-9272-11a64dd82431',
        href: cleanHref('#/search#42342542-6076-40fc-9272-11a64dd82431'),
        title: 'Part 3',
    },
]}/>*/}


                    {/*   <Button  onClick={() => handleScroll('section1')} >11</Button>

                    <Link to="#/search#42342542-6076-40fc-9272-11a64dd82431">Link to Hash Fragment</Link>
                    <HashLink to="#/search#42342542-6076-40fc-9272-11a64dd82431"> Link to div</HashLink>
                  */}


                    <div className="admin-search-results-shell">

                      {/*  <div style={{flexGrow:1}}>


                            {return_data_knowledge_detail_search_u.info.scene.length <= 0 ? <></> :
                                <div> {return_data_knowledge_detail_search_u.message !== 2000 ? <div></div> :

                                    <Anchor offsetTop={90}
                                        items={return_data_knowledge_detail_search_u.info.scene.map(item1 => ({key: item1.uuid, href: '#' + item1.uuid, title: item1.tab1_info.sort_name}))}
                                        onClick={(e) => handleAnchorClick(e, e.target)}

                                        style={{


                                            width: '90px',
                                        }}/>
                                }</div>}

                        </div>*/}


                        <div

                            style={{
                                flexGrow: 0,
                                width: '100%',

                                height: '100%',
                                minHeight: 0,
overflow: 'auto',
                            }}>

                            <div> {return_data_knowledge_detail_search_u.message !== 2000 ? <div style={{marginLeft: 20, marginRight: 20,}}> <Result
                                    icon={<SearchOutlined />}
                                    title="请输入搜索内容"
                                    /*    extra={<Button type="primary">Next</Button>}*/
                                /></div>  :


                                <div>{return_data_knowledge_detail_search_u.info.scene.length <= 0 ? <div style={{marginLeft: 20, marginRight: 20,}}><Result
                                        icon={<ExclamationCircleOutlined />}
                                        title="无匹配数据"
                                        /*    extra={<Button type="primary">Next</Button>}*/
                                    /></div> :
                                    <div>
                                        <div>{return_data_knowledge_detail_search_u.info.scene.map(item1 => (
                                            <div
                                                style={{display: 'flex', marginLeft: 20, marginRight: 20,}} /*id={item1.uuid}*/>

                                                {/* <label>{item1.uuid}</label>*/}
                                                <div
                                                    style={{

                                                        /*backgroundColor: getRandomColor(),*/
                                                        width: 5,
                                                        height: 40
                                                    }}></div>


                                                <div id={'' + item1.uuid}
                                                     style={{

                                                         width: '100%'
                                                     }}>


                                                    <div>
                                                        {/*

                                        {item1.product_info.brand_id}
*/}

                                                        商品名称：{item1.product_info.name}

                                                    </div>

                                                    <div>

                                                        问题名称{item1.title}


                                                    </div>


                                                    <div>

                                                        <label>分类信息：{item1.tab1_info.sort_name}{/*{'->'}{item1.tab2_info.sort_name}*/}</label>

                                                    </div>


                                                    <div>


                                                        问法条目

                                                        <div>
                                                            {item1.scene_question.map((item_qu) => (

                                                                <div
                                                                    key={item_qu.uuid}>
                                                                    {item_qu.title}
                                                                </div>


                                                            ))}
                                                        </div>

                                                        <p></p>
                                                        <label>回复内容</label>
                                                        <p></p>


                                                        {item1.scene_solution.length <= 0 ? <>找不到信息</> :     <div
                                                            style={{}}>
                                                            {item1.scene_solution.map((item_qu: any) => (


                                                                <Card
                                                                    style={{
                                                                        width: '100%',marginBottom: 8,

                                                                    }} onClick={() => copy_clipbord(item_qu.title)}>

                                                                    <label
                                                                        style={{width: '100%'}}>
                                                                        {item_qu.title}
                                                                    </label>


                                                                    <p></p>

                                                                    <div style={{display: 'flex'}}>


                                                                        <div style={{flexGrow: 1}}>


                                                                        </div>


                                                                        <div>


                                                                            <CopyOutlined
                                                                                style={{}}
                                                                                onClick={(event) => {
                                                                                    event.stopPropagation();
                                                                                    copy_clipbord(item_qu.title)
                                                                                }}>复制</CopyOutlined>

                                                                            {/*   <SendOutlined
                                                                                style={{marginLeft: 10}}
                                                                                onClick={(event) => {
                                                                                    event.stopPropagation();
                                                                                    send_message(item_qu.title)
                                                                                }}>复制</SendOutlined>*/}
                                                                        </div>
                                                                    </div>

                                                                </Card>

                                                            ))}
                                                        </div>}



                                                        {/*      <Anchor  onClick={handleAnchorClick}
                                                    items={return_data_knowledge_detail_search_u.info.scene.map(item1 => ({key:item1.uuid,href:'#'+item1.uuid,title:item1.title}))}
                                                />
*/}
                                                    </div>

                                                    <Divider/>


                                                </div>

                                            </div>))}</div>
                                    </div>}</div>

                            }

                            </div>

                        </div>

                    </div>
                </Flex>


            </Card>
            <FloatButton.Group className="admin-float-actions">
                <FloatButton icon={<ReloadOutlined/>} tooltip="刷新搜索结果" onClick={() => {
                    setknowledge_detail_search_u_modal_onfinish_select_log({message: 'refresh', value: '', time: dayjs().unix()});
                    setsearch_fetch_product_keybord_select_log({message: 'refresh', value: '', time: dayjs().unix()});
                }}/>
            </FloatButton.Group>

        </div>
    )

}

export default Search_ui_index;
